import React, { Component } from 'react';
import styles from './RequestView.module.css';
import TimeLine from '../../components/TimeLine';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getUser } from '../../modules/users';
import { getRequest, updateRequest } from '../../modules/requests';
import { fetchComments, createComment } from '../../modules/comments';
import { getHistory } from '../../modules/history';
import Divider from '../../components/Divider';

class RequstList extends Component {
  state = {
    comments: [],
    history: [],
  };
  static contextTypes = {
    router: PropTypes.object,
  };

  async componentWillMount() {
    const { router } = this.context;
    const { fetchComments, getHistory, getRequest } = this.props;
    const { id } = router.route.match.params;
    const request = await getRequest(id);
    const catogary = request.catogary;
    const comments = await fetchComments(catogary, request.modelId);
    const history = await getHistory(request.modelId, catogary);
    this, this.setState({ history, request, comments });
  }

  navTo = (id, cat) => {
    const { router } = this.context;
    const url = `/${cat}${id ? `/${id}` : ''}`;
    router.history.push(url);
  };

  createComment = (attrs, catogary) => {
    const { createComment, updateRequest, getHistory } = this.props;
    let { request, history } = this.state;
    if (attrs.type === 'approve') {
      updateRequest(request._id, { closedAt: new Date() });
      request.closedAt = new Date();
    }

    return createComment(attrs, catogary).then(async comment => {
      const { comments } = this.state;
      if (attrs.type !== 'normal') {
        history = await getHistory(request.modelId, request.catogary, true);
      }
      this.setState({ comments, request, history });
      return comments;
    });
  };

  render() {
    const { user } = this.props;
    const { history, comments, request } = this.state;
    if (!request) return null;
    return (
      <div className={styles.newModel}>
        <div className={styles.header}>{request.title}</div>
        <Divider />
        <TimeLine
          comments={comments}
          createComment={this.createComment}
          history={history}
          user={user}
          request={request}
        />
      </div>
    );
  }
}

export default connect(
  state => ({
    user: getUser(state),
  }),
  {
    fetchComments,
    createComment,
    getHistory,
    getRequest,
    updateRequest,
  }
)(RequstList);



// WEBPACK FOOTER //
// ./src/containers/RequestView/index.js